<template>
  <iRow vertical-align="top" align="center">
    <iColumn align="left" :width="720">
      <iSpace :height="40" />
      <iHeading variant="accent" font-size="displayLarge">
        Authorized apps
      </iHeading>
      <iText font-size="medium">
        Third-party apps you've granted access to your q3po data.
        Revoking an app invalidates all outstanding tokens — the next
        request from it will require fresh consent.
      </iText>
      <iSpace :height="16" />
      <iLoadingSpinner v-if="loading" />
      <iText v-else-if="grantList.length === 0" font-size="medium" variant="muted">
        No apps authorized yet.
      </iText>
      <iColumn v-for="grant in grantList" :key="grant.id" gap="small">
        <iRow vertical-align="middle" gap="medium">
          <iColumn :width="400" align="left">
            <iText font-size="large">
              <strong>{{ grant.app_display_name }}</strong>
            </iText>
            <iText font-size="small" variant="muted">
              Authorized {{ formatTimestamp(grant.granted_at) }}
            </iText>
            <iText v-if="grant.scopes" font-size="small" variant="muted">
              Scopes: {{ grant.scopes }}
            </iText>
          </iColumn>
          <iColumn :width="160" align="right">
            <iButton
              variant="danger"
              :is-loading="loadingRevoke === grant.id"
              @click="revoke(grant)"
            >
              Revoke
            </iButton>
          </iColumn>
        </iRow>
        <iDivider />
      </iColumn>
      <iText v-if="errorMessage" variant="error">
        {{ errorMessage }}
      </iText>
    </iColumn>
  </iRow>
</template>

<script>
import { $axios } from "@bloglovin/vue-framework";

export default {
  name: "GrantsList",
  props: {
    grants: { type: Array, default: null },
  },
  data() {
    return {
      grantList: Array.isArray(this.grants) ? [...this.grants] : [],
      loading: !Array.isArray(this.grants),
      loadingRevoke: 0,
      errorMessage: "",
    };
  },
  created() {
    if (Array.isArray(this.grants)) {
      return;
    }
    $axios.get("app-auth/grants").then(response => {
      this.grantList = Array.isArray(response?.data?.grants) ? response.data.grants : [];
      this.loading = false;
    }).catch(error => {
      const reason = error?.response?.data?.error ?? error?.message ?? String(error);
      console.error("GET app-auth/grants failed, so the authorized-apps list is empty", { reason, status: error?.response?.status ?? null }); // eslint-disable-line no-console
      this.errorMessage = `Could not load your authorized apps (${reason}).`;
      this.loading = false;
    });
  },
  methods: {
    revoke(grant) {
      this.loadingRevoke = grant.id;
      this.errorMessage = "";
      $axios.delete("app-auth/grant", {
        params: { app_slug: grant.app_slug },
      }).then(() => {
        this.grantList = this.grantList.filter(g => g.id !== grant.id);
        this.loadingRevoke = 0;
      }).catch(error => {
        this.errorMessage = error?.response?.data?.error ?? "Revoke failed.";
        this.loadingRevoke = 0;
      });
    },
    formatTimestamp(unixSeconds) {
      return new Date(unixSeconds * 1000).toLocaleString();
    },
  },
};
</script>
